import React from 'react';
import { arrayOf, object } from 'prop-types';
import { connect } from 'react-redux';
import { getRecurringOptions } from '../../../../../../../../reducers/packages';
import { translateHowLongAgo } from '../../../../../../../../utils/recurring/translation';

import './style.scss';

const SingleRecurringOption = ({ recurringOptions }) => {

    const [firstRecurringOption] = recurringOptions;
    const { duration, durationTimeUnit } = firstRecurringOption;

    return (
        <span className="single-recurring-option">
            {translateHowLongAgo(duration, durationTimeUnit)}
        </span>
    );
};

SingleRecurringOption.propTypes = {
    recurringOptions: arrayOf(object)
};

const mapStateToProps = ({ packages }) => {
    const recurringOptions = getRecurringOptions(packages);

    return { recurringOptions };
};

export { SingleRecurringOption };
export default connect(mapStateToProps)(SingleRecurringOption);
